import React from 'react';

import * as styles from './ImageNumberLabel.styles';

export interface ImageNumberLabelProps {
  currentImage: number;
  totalImages: number;
}

export const ImageNumberLabel = ({ currentImage, totalImages }: ImageNumberLabelProps) => {
  return (
    <p aria-hidden="true" css={styles.imageNumberLabel}>
      {currentImage}/{totalImages}
    </p>
  );
};
